import { Maybe, Payment } from '../../../../gql/gql-types';

export const latestPaymentState = (payment: Maybe<Payment>) =>
  payment?.job.items?.sort((a, b) => (b?.createdAt || '').localeCompare(a?.createdAt || ''))?.[0];
